import { Controller } from "@hotwired/stimulus"

// `?` opens the shortcuts sheet; `g` and then a letter jumps to a page.
// Keys typed in a field are left alone.
export default class extends Controller {
  static targets = ["dialog"]
  static values = { jumps: Object }

  connect() {
    this.onKey = this.onKey.bind(this)
    document.addEventListener("keydown", this.onKey)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKey)
  }

  onKey(event) {
    if (event.metaKey || event.ctrlKey || event.altKey || this.typing(event.target)) return

    if (this.pending) {
      this.pending = false

      const path = this.jumpsValue[event.key.toLowerCase()]

      if (path) window.Turbo.visit(path)

      return
    }

    if (event.key === "?") {
      event.preventDefault()
      this.open()
    } else if (event.key === "g") {
      this.pending = true
      setTimeout(() => (this.pending = false), 1200)
    }
  }

  typing(target) {
    return target.closest("input, textarea, select, [contenteditable]") || document.querySelector("dialog[open]")
  }

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  backdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
